var snapAccess = (function(module, $) {

  'use strict';

  var init, grantAccess, denyAccess;

  var accessGranted, settings;

  var $container, $addToCart, $addToCartText, $pinInput, $pinCode, $optionSelector;

  var adjustSnapaccess;

  init = function (options) {
    settings = {
      grantedClass: '.is-granted',
      pinInputSelector: '.snapaccess__code__input',
      pinCodeSelector: '.snapaccess__pin',
      addToCartTextSelector: '.btn__content',
      optionSelector: '.js-product-option-input',
      optionContainer: '.product-single__options',
    };

    settings = jQuery.extend(settings, options);

    $container = $(settings.containerSelector);
    $addToCart = $container.find(settings.addToCartSelector);
    $addToCartText = $addToCart.find(settings.addToCartTextSelector);
    $pinInput = $container.find(settings.pinInputSelector);
    $pinCode = $container.find(settings.pinCodeSelector);
    $optionSelector = $container.find(settings.optionSelector);

    accessGranted = false;

    if (typeof $container.data('product-pin') === 'undefined' && !settings.isForcedSoldOut) {
      return false;
    }

    adjustSnapaccess(settings.isForcedSoldOut);
  };

  adjustSnapaccess = function(isForcedSoldOut) {
    denyAccess(isForcedSoldOut);

    $pinInput.on('input', function(event) {
      event.stopImmediatePropagation();
      var $el = $(this);
      var accessVal = $container.attr('data-product-pin').toLowerCase();

      if ($(this).val().length == $(this).attr('maxlength')) {
        $el.next('input:text').focus();
      }

      var inputVal = $('#snappin1').val() + $('#snappin2').val() + $('#snappin3').val();
      if (inputVal.toLowerCase() === accessVal) {
        var target = event.target;
        grantAccess(target);
      }
    });
  };

  grantAccess = function(target) {
    $container.find(settings.optionContainer).removeClass('hide');
    $container.find('.shopify-payment-button').removeClass('hide');
    $container.find('.snapchat-placeholder').addClass('hide');
    $container.find(settings.addToCartSelector).prop('disabled', false).removeClass('disabled snapaccess--locked color-red');
    $container.find(settings.addToCartTextSelector).text('Add to cart');
    $container.find(settings.optionSelector).prop('disabled', false);
    $pinInput.remove();
    accessGranted = true;
  };

  denyAccess = function(isForcedSoldOut) {
    $addToCart.addClass(isForcedSoldOut ? 'color-red' : 'disabled snapaccess--locked');
    $addToCart.prop('disabled', true);
    $pinInput.prop('disabled', false);
    $optionSelector.prop('disabled', true);
    $addToCartText.html(isForcedSoldOut ? '<span>Sold Out</span>' : '<span>Locked</span>');
    accessGranted = false;
  };

  module = {
    init: init
  };

  return module;

}(snapAccess || {}, jQuery));
